const levels = [
  {
    icon: '/images/icons/loyalty-levels/gold.svg',
    status: 'gold',
    line_items: [
      '$10 on your birthday! Because nothing says “Happy Birthday” like free alcohol. Just make sure you’ve signed up 7 days before your special day, and have made one point-earning transaction on that account!'
    ]
  },
  {
    icon: '/images/icons/loyalty-levels/platinum.svg',
    status: 'platinum',
    line_items: [
      'All benefits available to gold members',
      'Saucey swag',
      'Special or early access to deals and promotions (it’s like having happy hour delivered to your door)'
    ]
  },
  {
    icon: '/images/icons/loyalty-levels/black.svg',
    status: 'black',
    line_items: [
      'All benefits available to gold and platinum members',
      'Possible access to benefits from partnering brands/companies',
      'Possible access to concierge booking services for events and orders',
      'Other fun perks that trust us, you’re definitely going to want ;)'
    ]
  }
];

const snippets = [
  {
    title: 'make your first purchase',
    points: 1000
  },
  {
    title: 'download our app',
    points: 500
  },
  {
    title: 'invite a friend',
    points: 500
  }
];

export { levels, snippets };
